// extracted by mini-css-extract-plugin
module.exports = {"container":"cookie-notice_container__25Hhl","title":"cookie-notice_title__1nqUP","body":"cookie-notice_body__3GoY-"};